// Libraries
import React, {useEffect, useState} from 'react';
import {Icon} from 'Components/index';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

// Style
import {DropdownWrapper} from './index.style';

const PATH = 'Src/Components/Zoom/index.js';

interface IConstant {
    ADD?: number,
    SUB?: number,
    DROPDOWN_ITEM: Array<{label?: string, value?: number}>
}

interface IZoom {
    styleIcon?: React.CSSProperties,
    classNameButton?: string,
    percentNumber?: number,
    showNumberZoom?: boolean,
    width?: string,
    max?: number,
    min?: number,
    interval?: number,
    onError?: (error: any, detail: Record<string, unknown>) => void,
    onChange?: (value: any) => void
}

const constant: IConstant = {
    ADD: 1,
    SUB: 2,
    DROPDOWN_ITEM: [
        {label: '100%', value: 100},
        {label: '90%', value: 90},
        {label: '80%', value: 80},
        {label: '70%', value: 70},
        {label: '60%', value: 60},
        {label: '50%', value: 50},
        {label: '40%', value: 40},
        {label: '30%', value: 30},
        {label: '20%', value: 20},
        {label: '10%', value: 10}
    ]
};

const Zoom: React.FC<IZoom> = (props) => {
    // Props
    const {min = 0, max = 0, interval = 0.1} = props;

    // State
    const [isOpen, setIsOpen] = useState(false);
    const [percentValue, setPercentValue] = useState(1);

    useEffect(() => {
        try {
            if (props.percentNumber && typeof props.percentNumber === 'number') {
                const percentValueFormat = Number(props.percentNumber).toFixed(2);

                setPercentValue(+percentValueFormat);
            }
        } catch (e) {
            typeof props.onError === 'function' && props.onError(e, {
                component: PATH,
                action: 'useEffect -> setPercentValue',
                args: {}
            });
        }
    }, [props.percentNumber]);

    const onClickZoom = (status) => {
        try {   
            if (status) {
                const interalFormat = +interval;
                const {percentMultiplicationValue} = percentMultiplication(percentValue);

                if (status === constant.ADD && percentMultiplicationValue < max) {
                    const addValue = percentValue + interalFormat;

                    typeof props.onChange === 'function' && props.onChange(addValue);
                }
                
                if (status === constant.SUB && percentMultiplicationValue > min) {
                    const minusValue = percentValue - interalFormat;

                    typeof props.onChange === 'function' && props.onChange(minusValue);
                }
            }
        } catch (e) {
            typeof props.onError === 'function' && props.onError(e, {
                component: PATH,
                action: 'onClickZoom',
                args: {
                    status
                }
            });
        }
    };

    const percentDivision = (percentValue: number): {percentDivisionValue: number} => {
        if (percentValue && typeof percentValue === 'number') {
            const percentDivisionValue: number = percentValue / 100;

            return {percentDivisionValue};
        }

        return {percentDivisionValue: 0};
    };

    const percentMultiplication = (percentValue): {percentMultiplicationValue: number}  => {
        if (percentValue && typeof percentValue === 'number') {
            const percentMultiplicationValue: number = percentValue * 100;

            return {percentMultiplicationValue};
        }

        return {percentMultiplicationValue: 0};
    };

    const dropDownToggle = () => {
        try {
            setIsOpen(!isOpen);
        } catch (e) {
            typeof props.onError === 'function' && props.onError(e, {
                component: PATH,
                action: 'dropDownToggle',
                args: {}
            });
        }
    };

    const onClickDropdownItem = (dropdownValue) => {
        try {
            if (dropdownValue) {
                const {percentDivisionValue} = percentDivision(dropdownValue);
    
                setPercentValue(percentDivisionValue);

                if (typeof props.onChange === 'function') {
                    props.onChange(percentDivisionValue);
                }
            }
        } catch (e) {
            if (typeof props.onError === 'function') {
                props.onError(e, {
                    component: PATH,
                    action: 'onClickDropdownItem',
                    args: {dropdownValue}
                });
            }
        }
    };

    try {
        return (
            <div className='d-flex align-items-center dropdown-menu-zoom' style={{zIndex: 20}}>
                {props.showNumberZoom ? (
                    <DropdownWrapper>
                        <Dropdown isOpen={isOpen} toggle={dropDownToggle} >
                            <DropdownToggle
                                color={'default'}
                                caret
                                onClick={dropDownToggle}
                            >
                                {`${percentValue * 100}%`}
                            </DropdownToggle>
                            <DropdownMenu style = {{outline: 'none'}} className={'box-shadow'}>
                                {
                                    constant.DROPDOWN_ITEM.map((item, index) => (
                                        <DropdownItem
                                            key={index}
                                            onClick={() => {onClickDropdownItem(item.value)}}
                                        >
                                            {item.label}
                                        </DropdownItem>
                                    ))
                                }
                            </DropdownMenu>
                        </Dropdown>
                    </DropdownWrapper>
                ) : null}
                <div className='btn-zoom-wrapper' style={{width: props.width}}>
                    <button disabled={(percentValue * 100) === props.min} className={props.classNameButton} onClick={() => onClickZoom(constant.SUB)}>
                        <Icon
                            type='icon-antsomi-minus'
                            style={props.styleIcon}
                        />
                    </button>
                    <button disabled={(percentValue * 100) === props.max} className={props.classNameButton} onClick={() => onClickZoom(constant.ADD)}>
                        <Icon
                            type='icon-antsomi-add'
                            style={props.styleIcon}
                        />
                    </button>
                </div>
            </div>
        );
    } catch (e) {
        if (typeof props.onError === 'function') {
            props.onError(e, {
                component: PATH,
                action: 'render -> Zoom',
                args: {}
            });
        }
        return <div>Error</div>;
    }
};

Zoom.defaultProps = {
    styleIcon: {
        color: '#00000087', 
        fontSize: '10px'
    },
    classNameButton: 'btn-zoom',
    percentNumber: 1,
    showNumberZoom: true,
    width: '75px',
    max: 100,
    min: 10,
    interval: 0.1
};

export default Zoom;
